import withStyles from '@mui/styles/withStyles';

const styles = {
  link: {
    '&:hover': {
      color: 'initial',
    },
  },
};

const ListedLink = ({ children, href, classes, className = null, dataEvent = null }) => (
  <li className={className}>
    <a className={classes.link} href={href} data-event={dataEvent}>
      {children}
    </a>
  </li>
);

export default withStyles(styles)(ListedLink);
